import { useCallback } from 'react';
import { AppRoutes } from '../../../../constants';
import { useAppDispatch } from '../../../../hooks';
import { ProspectFooterFields, setProspectForm } from '../../../../redux/reducers';
import { PracticeProspectDetails } from '../../../../types';
import { Icon, TextButton, Typography } from '../../../shared';

interface ProcessingSuccessStateProps {
  aiTwinDetails: Omit<PracticeProspectDetails, ProspectFooterFields>;
}

const ProcessingSuccessState = ({ aiTwinDetails }: ProcessingSuccessStateProps) => {
  const dispatch = useAppDispatch();

  const handleCheckDetails = useCallback(() => {
    dispatch(
      setProspectForm({
        prospect: aiTwinDetails,
        canManageProspect: true,
      })
    );

    // Update URL without triggering navigation or API refetches
    window.history.replaceState(
      { personaId: aiTwinDetails.personaId },
      '',
      `${AppRoutes.PROSPECT}/${aiTwinDetails.personaId}`
    );
  }, [aiTwinDetails, dispatch]);

  return (
    <div className="flex h-32 flex-col gap-2">
      <div className="flex flex-col items-center gap-2">
        <style>
          {`
            .checkmark-container {
              width: 60px;
              height: 60px;
            }

            .checkmark {
              width: 100%;
              height: 100%;
            }

            .checkmark__check {
              stroke-dasharray: 48;
              stroke-dashoffset: 48;
              stroke-width: 6;
              stroke: #0AAD7C;
              stroke-linecap: round;
              stroke-linejoin: round;
              animation: checkmark 0.8s ease-in-out forwards;
            }

            @keyframes checkmark {
              0% {
                stroke-dashoffset: 48;
              }
              100% {
                stroke-dashoffset: 0;
              }
            }
          `}
        </style>
        <div className="checkmark-container">
          <svg className="checkmark" viewBox="0 0 52 52">
            <path className="checkmark__check" fill="none" d="M14 27.6l7.2 7.2 16.8-16.8" />
          </svg>
        </div>
        <Typography>AI twin complete!</Typography>
      </div>
      <div className="flex justify-end">
        <TextButton text="Check the details" endIcon={Icon.CHEVRON_RIGHT} onClick={handleCheckDetails} />
      </div>
    </div>
  );
};

export default ProcessingSuccessState;
